import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, PrimaryButton } from "extranet-component-library";

interface FavsProps {
  visible: boolean;
  timetables: Array<any>;
  clicked: number;
  download: (data: any) => void;
  close: () => void;
  setClicked: (index: number) => void;
}

const ModalTimetables = ({ ...props }: FavsProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible={props.visible}
      content={
        <>
          <div className="title">{t("fav_lines")}</div>
          <div className="subtitle">{t("available_timetables")}</div>
          <div className="timetables">
            {props.timetables &&
              props.timetables.map((timetable: any, index: number) => {
                return (
                  <div
                    onClick={() => props.setClicked(index)}
                    key={index}
                    className={`flex-container justify-evenly timetable ${props.clicked === index ? "active" : ""
                      }`}
                  >
                    <div>{timetable.name}</div>
                  </div>
                );
              })}
          </div>
          <div className="center-content">
            <PrimaryButton
              disabled={props.clicked !== -1 ? false : true}
              text={t("download_timetables")}
              onClick={() => props.download(props.timetables[props.clicked].url)}
            />
          </div>
        </>
      }
      onHide={() => props.close()}
    />
  );
};

export default ModalTimetables;
